<template>
    <el-dialog 
        :visible="openDialog"
        :close-on-click-modal="false"
        title="Import from Campaign"
        append-to-body
        @close="closeDialog">

        <job-select
            :show_job="false"
            @selected="selectJob"
        ></job-select>

        <span slot="footer" class="dialog-footer">
            <el-button 
                :disabled="processing" 
                @click="closeDialog"
            >
                Close
            </el-button>
            <el-button 
                :disabled="processing || ! campaign_id"
                @click="process"
                type="success"
            >
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> Add hiring area
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import JobSelect from '../../../accounts/JobSelect/vue/job-select.vue';

export default {
    components: { 
        JobSelect
    },
    props: {
        openDialog: { type: Boolean, required: true },
        areaId: { type: Number, required: true },
    },
    data() {
        return {
            campaign_id: null,
            processing: false,
        };
    },
    methods: {
        selectJob(result) {
            this.campaign_id = result.campaign_id;
        },
        process() {
            this.processing = true;
            this.errorMessage = null;

            axios.post(this.url(`admin/area/import-from-campaign`), {
                area_id: this.areaId,
                campaign_id: this.campaign_id,
            })
            .then(response => {
                this.closeDialog();
                this.$emit('process');
            })
            .finally(() => { this.processing = false; });
        },
        closeDialog() {
            this.$emit('update:openDialog', false);
        },
    },
};
</script>
<style scoped>
.mt-10 {
    margin-top: 10px;
}
</style>